import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles(() => ({
  customerInfoWrapper: {
    margin: '80px auto',
  },
  backBtn: {
    cursor: 'pointer',
    margin: '40px auto 0',
  },
  galleryContainer: {
    margin: '0 auto',
  },
  imageWrapper: {
    marginBottom: 15,
    paddingRight: 10,
    paddingLeft: 10
  },
  buttonWrapper: {
    height: '60px'
  },
  modalBody: {
    top: '50%',
    position: 'absolute',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '15px',
    backgroundColor: 'white',
    border: 0,
    "@media (max-width: 650px)": {
      width: '90%'
    }
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  examViewHeader: {
    margin: '0 auto',
    "@media (max-width: 1136px)": {
      margin: '40px auto'
    }
  }
}));